import { fetchData, fetch as _fetch, fetchRawResponse } from '@tomra/client-side-http-client'
import { keycloak } from './authentication'

const defaultConfig = {
  fetchNewToken: () => keycloak.updateToken(),
  getToken: () => keycloak.token ?? '',
  timeoutInMs: 60000
}

export const authenticatedFetchData = (url: string, options = {}, config = {}) => {
  return fetchData(url, options, { ...defaultConfig, ...config })
}

export const authenticatedFetchRaw = (url: string, options = {}, config = {}) => {
  return fetchRawResponse(url, options, { ...defaultConfig, ...config })
}

export const authenticatedFetch = (url: string, options = {}, config = {}) => {
  return _fetch(url, options, { ...defaultConfig, ...config })
}
